import LocationAware from './LocationAware.vue'

export default LocationAware